<template>
    <div class="row no-gutters">
        <div class="col-12">
            <div class="row no-gutters justify-content-center">
                <div class="col-12 statistics-header">
                    <div class="row no-gutters justify-content-center">
                        
                    </div>
                    <div class="row no-gutters justify-content-space-evenly" style="margin-top:2%">
                        <div v-bind:class="{'tab-header-clicked': raceStatisticsTabStates.raceIndex}" v-on:click="onStatisticsTabClicked('raceIndex')" class="col-5 col-md-2 text tab-header text-center"><span>INDEX</span></div >
                        <div v-bind:class="{'tab-header-clicked': raceStatisticsTabStates.magicTips}" v-on:click="onStatisticsTabClicked('magicTips')" class="col-5 col-md-2 text tab-header text-center"><span>MAGIC TIPS</span></div >
                        <div v-bind:class="{'tab-header-clicked': raceStatisticsTabStates.whosHot}" v-on:click="onStatisticsTabClicked('whosHot')" class="col-5 col-md-2 text tab-header text-center"><span>WHO'S HOT</span></div >    
                        <div v-bind:class="{'tab-header-clicked': raceStatisticsTabStates.national}" v-on:click="onStatisticsTabClicked('national')" class="col-5 col-md-2 text tab-header text-center"><span>NATIONAL</span></div >
                    </div>
                </div>
            </div>
            <div v-if="!raceStatisticsTabStates.national" class="row no-gutters justify-content-center">
                <div class="d-none col-md-4 d-md-flex justify-content-center">
                    <img class="magic-tips-icon" v-if="raceStatisticsTabStates.magicTips" :src="getImage('magic-tips-icon')">
                </div>
                <div class="col-12 col-md-4 d-flex justify-content-center align-items-center mt-2 mt-md-0">
                    <div class="race-statistics-header py-2 px-5">
                        <div class="row no-gutters justify-content-center">
                            <span class="text race-statistics-header-venue">{{selectedRaceCardSummary.raceCardSummary.courseTitle}}</span>
                        </div>
                        <div class="row no-gutters justify-content-center">
                            <span class="race-statistics-header-distance text">{{selectedRaceCardSummary.raceCardSummary.raceDate}}</span>
                        </div>
                        <div class="row no-gutters justify-content-center">
                            <span class="race-statistics-sub-header-venue text">{{selectedRaceCardSummary.raceCardSummary.courseSubTitle}}</span>
                        </div>
                    </div>
                </div>
                <div v-if="raceStatisticsTabStates.magicTips" class="col-5 d-md-none d-flex justify-content-center">
                    <img class="magic-tips-icon" :src="getImage('magic-tips-icon')">
                </div>
                <div class="col-5 col-md-4 d-flex justify-content-center">
                    <img class="img-fluid race-track-icon"
                         :src="getImage(raceCourseAssets[selectedRaceCardSummary.raceCardSummary.raceTrackAssetId].raceCourseIcon)"/>
                </div>
            </div>
            <div v-if="raceStatisticsTabStates.whosHot" class="col-12">
                <whos-hot></whos-hot>
            </div>
            <div v-if="raceStatisticsTabStates.raceIndex" class="col-12">
                <race-index></race-index>
            </div>
            <div v-if="raceStatisticsTabStates.magicTips" class="col-12">
                <magic-tips></magic-tips>
            </div>
            <div v-if="raceStatisticsTabStates.national" class="col-12">
                <national-index></national-index>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex';

    import {TrainerIndexMockData} from '../assets/mockData/trainerIndex';
    import {BreederIndexMockData} from '../assets/mockData/breedingIndex';
    import {JockeyIndexMockData} from '../assets/mockData/jockeyIndex';
    import {HorseIndexMockData} from '../assets/mockData/horseIndex';

    import WhosHot from '../components/WhosHot';
    import RaceIndex from '../components/RaceIndex';
    import MagicTips from '../components/MagicTips';
    import NationalIndex from '../components/NationalIndex';
    import {RaceCourseAssets} from "../components/configuration/raceCourseAssetMapping.constant";

    export default {
        name: 'RaceStatistics',
        components: {WhosHot, RaceIndex, MagicTips, NationalIndex},
        data: function () {
            return {
                raceStatisticsTabStates: {
                    magicTips: false,
                    whosHot: false,
                    raceIndex: true,
                    national: false
                },
                isFormGridOpen: false,
                trainerIndexData: TrainerIndexMockData,
                breederIndexData: BreederIndexMockData,
                jockeyIndexData: JockeyIndexMockData,
                horseIndexData: HorseIndexMockData,
                raceCourseAssets: RaceCourseAssets
            };
        },
        computed: mapState(['selectedHorse', 'selectedTrainer', 'selectedJockey', 'selectedBreeder', 'selectedRaceCardSummary']),
        methods: {
            getImage(imagePath, fileType = 'svg') {
                return require('../assets/images/' + imagePath + '.' + fileType);
            },
            onStatisticsTabClicked(tabName) {
                if (this.raceStatisticsTabStates[tabName]) return;
                for(let tab in this.raceStatisticsTabStates) {
                    if(this.raceStatisticsTabStates[tab] && tabName === tab) {
                        this.raceStatisticsTabStates[tab] = false;
                        return;
                    }
                    this.raceStatisticsTabStates[tab] = tab === tabName;
                }
            },
            onBreederToggleClicked(toggleName) {
                if (this.breederToggleStates[toggleName]) return;
                for(let toggle in this.breederToggleStates) {
                    if(this.breederToggleStates[toggle] && toggleName === toggle) {
                        this.breederToggleStates[toggle] = false;
                        return;
                    }
                    this.breederToggleStates[toggle] = toggle === toggleName;
                }
            },
            onHorseNameClicked(horseId) {
                this.setSelectedHorse({});
                this.onStatisticsTabClicked('search');
            },
            onTrainerNameClicked(trainerId) {
                this.setSelectedTrainer({});
                this.onStatisticsTabClicked('search');
            },
            onJockeyNameClicked(jockeyId) {
                this.setSelectedJockey({});
                this.onStatisticsTabClicked('search');
            },
            onBreederNameClicked(breederId) {
                this.setSelectedBreeder({});
                this.onStatisticsTabClicked('search');
            },
            toggleFormGridVisibility() {
                this.isFormGridOpen = !this.isFormGridOpen;
            },
            ...mapMutations(['setSelectedHorse', 'setSelectedTrainer', 'setSelectedJockey', 'setSelectedBreeder'])
        },
        created: function () {
            if(!this.selectedRaceCardSummary) this.$router.push({ path: `/landing/home` });
        },
        mounted: function () {
            document.querySelector('.body-content').scrollTo(0, 0);
        }
    }
</script>

<style scoped>
    .race-statistics-header {
        position: relative;
        background-color: #000000;
        border-radius: 0.4rem;
        border: none;
    }

    .race-statistics-header-venue {
        font-size: 1.2rem;
        font-weight: bold;
    }

    .race-statistics-sub-header-venue {
        font-size: 1.05rem;
        font-weight: bold;
    }

    .race-statistics-header-distance {
        font-size: 0.9rem;

    }

    .race-track-icon {
        width: 50%;
    }

    .table td {
        padding-top: 0.4rem;
        padding-bottom: 0.4rem;
    }

    .statistics-header {
        background-color: #000000;
    }

    .statistics-title-text {
        font-size: 1.8rem;
    }

    .tab-header {
        font-size: 0.8rem;
        padding: 0.5rem 0;
        font-weight: bold;
    }

    .tab-header:hover {
        cursor: pointer;
    }

    .tab-header-clicked {
        background-color: #FFFFFF;
        color: #000000;
    }

    .magic-tips-icon {
        width: 50%;
    }

    @media only screen and (min-device-width: 0px) and (max-device-width: 1200px) and (orientation: landscape) {
        .race-track-icon {
            width: 35% !important;
            height: 100%;
        }
    }

    @media only screen and (min-device-width: 0px) and (max-device-width: 1200px) and (orientation: portrait) {
        .race-track-icon {
            width: 50% !important;
            height: 100%;
        }
    }

    @media (min-width: 768px) {
        .table td {
            padding-top: 0.75rem;
            padding-bottom: 0.75rem;
        }

        .tab-header {
            font-size: 1rem;
            padding: 0.5rem 0;
            font-weight: bold;
        }

        .magic-tips-icon {
            width: 35%;
        }

        .race-track-icon {
            width: 40%;
        }
    }
</style>
